export function setCookie(name, value, maxAge = 86400, path = '/') {
  document.cookie = `${name}=${encodeURIComponent(
    value,
  )}; Max-Age=${maxAge}; path=${path}`;
}
